// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import Widget from '@arcgis/core/widgets/Widget';
import { tsx } from '@arcgis/core/widgets/support/widget';

import SceneView from '@arcgis/core/views/SceneView';
import DistanceMeasurement3D from '@arcgis/core/widgets/DirectLineMeasurement3D';

import '@esri/calcite-components/dist/calcite/calcite.css';

interface DistanceProps {
  view:SceneView;
  measurement:DistanceMeasurement3D;
}

class DistanceWidget extends Widget {
  view: SceneView;

  measurement: DistanceMeasurement3D;

  isActive = false;

  name = 'distanceWidget3d';

  constructor(params: DistanceProps) {
    super(params);
    this.view = params.view;
    this.measurement = params.measurement;
  }

  _handleClick() {
    if (!this.isActive) {
      this.measurement.visible = true;
      this.measurement.viewModel.start();
      this.isActive = true;
    } else {
      this.measurement.viewModel.clear();
      this.measurement.visible = false;
      this.isActive = false;
    }
    this.emit('measurement-toggle', { active: this.isActive });
  }

  render() {
    return tsx(
      'div',
      {
        class: 'esri-widget esri-widget--button',
        style: 'cursor:pointer',
        onclick: this._handleClick.bind(this),
      },
      tsx('calcite-icon', {
        icon: this.isActive ? 'x' : 'measure-line',
        scale: 'm',
        title: this.isActive ? 'Stop Measurement' : 'Measure Distance',
      }),
    );
  }
}

export default DistanceWidget;
